
export default {
  tranksaksis: [],
  tranksaksiTags: [],
  tranksaksiFilter: null,
  tranksaksiKategoris: [],
  pembayarans: [],
  pembayaran_sisa: 0,
  pembayaran_total: 0,
  pembayaran_status: null,
  total: null,
  last: null,
  per_page: null,
  current_page: null,
  max_range: 0,
  state_range: null
}
